function validaTelefone(value) {
  const regexPhone = /^(\+55\s?)?(\(\d{2}\)\s?)?\d{4,5}-?\d{4}$/; // Regex para telefone brasileiro
  return regexPhone.test(value);
}

export default validaTelefone;
